export const BuildInfo = {timestamp:1781296842000}
